// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.map-container {
  width: 60%; /* Set map width to 100% */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column; /* Stack items vertically */
  margin: 0 auto; /* Center the map */
}

.map-content {
  width: 100%;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 10px; /* Add space between buttons */
  margin-bottom: 20px;
}

.fuel-button {
  padding: 10px 20px;
  font-size:0.7em;
  font-weight: bold;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.fuel-button:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.fuel-button:active {
  background-color: #004494;
  transform: scale(1);
}

.fuel-button.active {
  background-color: #004494; /* Different color for active state */
}

.legend-container {
  width: 100%; /* Ensure legend takes full width */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px; /* Move legend below the map */
  margin-bottom: 20px;
}

.legend {
  display: grid;
  grid-template-columns: repeat(8, 1fr); /* Create 8 equal columns */
  margin: 0 10px; /* Add some margin to the sides */
  width: 100%;
}

.legend-block {
  height: 15px; /* Set height for the blocks */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white; /* Text color */
  font-size: 0.8em; /* Font size */
  font-weight: bold;
}

.legend-labels {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
}

.legend-labels span {
  font-size: 1em;
  color: #333;
  font-weight: bold;
}

.state-price-list {
  margin-top: 20px;
  width: 100%;
  overflow-x: auto; /* Enable horizontal scrolling on small screens */
}

.state-price-list table {
  width: 100%;
  border-collapse: collapse;
}

.state-price-list th, .state-price-list td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.state-price-list th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.unit-tabs {
  border-radius: 5px;
  overflow: hidden;
}

.unit-tab {
  padding: 4px 16px;
  font-size: 0.9em;
  width: 10%;
  font-weight: bold;
  color: #007bff;
  background-color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  border-radius: 5px;
  border: 1px solid #a7a7a7;
}

.unit-tab:hover {
  background-color: #f1f1f1;
}

.unit-tab.active {
  background-color: #007bff;
  color: #fff;
}

.footer {
  width: 100%;
  background-color: #007bff;
  color: white;
  padding: 10px 0;
  margin-top: 20px;
}

.footer p {
  margin: 0;
  font-size: 1em;
}

/* Media Queries for Mobile Responsiveness */
@media (max-width: 768px) {
  .map-container {
    width: 100%;
  }

  .legend {
    grid-template-columns: repeat(auto-fit, minmax(50px, 1fr)); /* Adjust legend columns on smaller screens */
  }

  .fuel-button {
    padding: 8px 16px;
    font-size: 0.9em;
  }

  .header h1 {
    font-size: 1.5em;
  }

  .header p {
    font-size: 1em;
  }
}

@media (max-width: 480px) {
  .map-container {
    width: 100%;
  }

  .legend {
    grid-template-columns: repeat(auto-fit, minmax(0px, 1fr)); /* Adjust legend columns on smaller screens */
  }

  .fuel-button {
    padding: 6px 12px;
    font-size: 0.8em;
  }

  .unit-tab {
    padding: 2px 16px;
    width: 45%;
    margin: 0px 8px;
  }

  .header h1 {
    font-size: 1.2em;
  }

  .header p {
    font-size: 0.9em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Map.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU,EAAE,0BAA0B;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB,EAAE,2BAA2B;EACnD,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAE,8BAA8B;EACzC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA;EACE,WAAW,EAAE,mCAAmC;EAChD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAE,8BAA8B;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,2BAA2B;EAClE,cAAc,EAAE,iCAAiC;EACjD,WAAW;AACb;;AAEA;EACE,YAAY,EAAE,8BAA8B;EAC5C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,eAAe;EAC7B,gBAAgB,EAAE,cAAc;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB,EAAE,iDAAiD;AACrE;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,uDAAuD;EACvD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE;IACE,WAAW;EACb;;EAEA;IACE,0DAA0D,EAAE,6CAA6C;EAC3G;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,yDAAyD,EAAE,6CAA6C;EAC1G;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.map-container {\n  width: 60%; /* Set map width to 100% */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column; /* Stack items vertically */\n  margin: 0 auto; /* Center the map */\n}\n\n.map-content {\n  width: 100%;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 10px; /* Add space between buttons */\n  margin-bottom: 20px;\n}\n\n.fuel-button {\n  padding: 10px 20px;\n  font-size:0.7em;\n  font-weight: bold;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.3s ease;\n}\n\n.fuel-button:hover {\n  background-color: #0056b3;\n  transform: scale(1.05);\n}\n\n.fuel-button:active {\n  background-color: #004494;\n  transform: scale(1);\n}\n\n.fuel-button.active {\n  background-color: #004494; /* Different color for active state */\n}\n\n.legend-container {\n  width: 100%; /* Ensure legend takes full width */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px; /* Move legend below the map */\n  margin-bottom: 20px;\n}\n\n.legend {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr); /* Create 8 equal columns */\n  margin: 0 10px; /* Add some margin to the sides */\n  width: 100%;\n}\n\n.legend-block {\n  height: 15px; /* Set height for the blocks */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white; /* Text color */\n  font-size: 0.8em; /* Font size */\n  font-weight: bold;\n}\n\n.legend-labels {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: bold;\n}\n\n.legend-labels span {\n  font-size: 1em;\n  color: #333;\n  font-weight: bold;\n}\n\n.state-price-list {\n  margin-top: 20px;\n  width: 100%;\n  overflow-x: auto; /* Enable horizontal scrolling on small screens */\n}\n\n.state-price-list table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.state-price-list th, .state-price-list td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.state-price-list th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.unit-tabs {\n  border-radius: 5px;\n  overflow: hidden;\n}\n\n.unit-tab {\n  padding: 4px 16px;\n  font-size: 0.9em;\n  width: 10%;\n  font-weight: bold;\n  color: #007bff;\n  background-color: #fff;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, color 0.3s ease;\n  border-radius: 5px;\n  border: 1px solid #a7a7a7;\n}\n\n.unit-tab:hover {\n  background-color: #f1f1f1;\n}\n\n.unit-tab.active {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.footer {\n  width: 100%;\n  background-color: #007bff;\n  color: white;\n  padding: 10px 0;\n  margin-top: 20px;\n}\n\n.footer p {\n  margin: 0;\n  font-size: 1em;\n}\n\n/* Media Queries for Mobile Responsiveness */\n@media (max-width: 768px) {\n  .map-container {\n    width: 100%;\n  }\n\n  .legend {\n    grid-template-columns: repeat(auto-fit, minmax(50px, 1fr)); /* Adjust legend columns on smaller screens */\n  }\n\n  .fuel-button {\n    padding: 8px 16px;\n    font-size: 0.9em;\n  }\n\n  .header h1 {\n    font-size: 1.5em;\n  }\n\n  .header p {\n    font-size: 1em;\n  }\n}\n\n@media (max-width: 480px) {\n  .map-container {\n    width: 100%;\n  }\n\n  .legend {\n    grid-template-columns: repeat(auto-fit, minmax(0px, 1fr)); /* Adjust legend columns on smaller screens */\n  }\n\n  .fuel-button {\n    padding: 6px 12px;\n    font-size: 0.8em;\n  }\n\n  .unit-tab {\n    padding: 2px 16px;\n    width: 45%;\n    margin: 0px 8px;\n  }\n\n  .header h1 {\n    font-size: 1.2em;\n  }\n\n  .header p {\n    font-size: 0.9em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
